<template>
  <div>
    <p v-for="line in storyLine.lines" :key="line.index" class="story-text-style">{{ line }}</p>
    <section
      v-if="userChoice[3] == 'fight' && userChoice[0] == 'father'"
      class="story-text-style story-button-container"
    >
      <button
        class="story-btn-style"
        @click="navigateTo('winFight__Father', true, 'CombatSkills')"
      >Fight with coordination</button>
      <button class="story-btn-style" @click="navigateTo('loseFight__Father')">Just fight</button>
    </section>

    <section
      v-if="userChoice[3] == 'seekHelp' && userChoice[0] == 'father'"
      class="story-text-style story-button-container"
    >
      <button
        class="story-btn-style"
        @click="navigateTo('clanOne__Father', true, 'Uno-Clan')"
      >Call for help</button>
      <button
        class="story-btn-style"
        @click="navigateTo('clanTwo__Father', true, 'Dos-Clan')"
      >Call for help</button>
    </section>

    <section
      v-if="userChoice[3] == 'hide' && userChoice[0] == 'mother'"
      class="story-text-style story-button-container"
    >
      <button
        class="story-btn-style"
        @click="navigateTo('clanOne__Mother', true, 'Uno-Clan')"
      >Keep Hoping</button>
      <button
        class="story-btn-style"
        @click="navigateTo('clanTwo__Mother', true, 'Dos-Clan')"
      >Keep Hoping</button>
    </section>

    <section
      v-if="userChoice[3] == 'fight' && userChoice[0] == 'mother'"
      class="story-text-style story-button-container"
    >
      <button
        class="story-btn-style"
        @click="navigateTo('winFight__Mother', true, 'CombatSkills')"
      >Fight with Coordination</button>
      <button class="story-btn-style" @click="navigateTo('loseFight__Mother')">Just fight</button>
    </section>
  </div>
</template>

<script>
export default {
  name: "Story-Five",
  data() {
    return {
      userTrait: this.$store.state.userPersonality,
      userChoice: this.$store.state.userChoices
    };
  },
  computed: {
    storyLine() {
      return this.$store.state.Five[this.userChoice[3]];
    }
  },
  methods: {
    navigateTo(choice = "none", isTraitRequired = false, trait = "") {
      let checkAccess, deniedReason;
      if (isTraitRequired) {
        if (this.userTrait.indexOf(trait) > -1) {
          checkAccess = true;
          this.$store.dispatch("updateChoice", choice);
        } else {
          checkAccess = false;
          deniedReason = `You don't have the particular trait: ${trait}`;
        }
        this.$store.commit("setModalDisplay", {
          display: true,
          isGranted: checkAccess,
          deniedReason,
          url: "/story/six"
        });
      } else {
        this.$store.dispatch("updateChoice", choice);
        this.$store.commit("setModalDisplay", {
          display: true,
          isGranted: true,
          url: "/story/six"
        });
      }
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/css/Scheme.scss";
</style>
